var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H16.5C16.8978 18 17.2794 17.842 17.5607 17.5607C17.842 17.2794 18 16.8978 18 16.5V1.5C18 1.10218 17.842 0.720644 17.5607 0.43934C17.2794 0.158035 16.8978 0 16.5 0ZM13.2806 7.28063L8.03063 12.5306C7.96097 12.6004 7.87825 12.6557 7.78721 12.6934C7.69616 12.7312 7.59856 12.7506 7.5 12.7506C7.40144 12.7506 7.30384 12.7312 7.21279 12.6934C7.12175 12.6557 7.03903 12.6004 6.96937 12.5306L4.71937 10.2806C4.57864 10.1399 4.49958 9.94902 4.49958 9.75C4.49958 9.55098 4.57864 9.36011 4.71937 9.21937C4.86011 9.07864 5.05098 8.99958 5.25 8.99958C5.44902 8.99958 5.63989 9.07864 5.78063 9.21937L7.5 10.9397L12.2194 6.21937C12.2891 6.14969 12.3718 6.09442 12.4628 6.0567C12.5539 6.01899 12.6515 5.99958 12.75 5.99958C12.8485 5.99958 12.9461 6.01899 13.0372 6.0567C13.1282 6.09442 13.2109 6.14969 13.2806 6.21937C13.3503 6.28906 13.4056 6.37178 13.4433 6.46283C13.481 6.55387 13.5004 6.65145 13.5004 6.75C13.5004 6.84855 13.481 6.94613 13.4433 7.03717C13.4056 7.12822 13.3503 7.21094 13.2806 7.28063Z",
    fill: "#005754",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/CheckGreen.3ec4147ce67e3613633462214655b2d6.svg";
export { ForwardRef as ReactComponent };